export const vOnEnterDefault = {
  mounted(el) {
    el.onkeydown = (event) => {
      // Modern replacement for event.keyCode == 13
      if (event.key === 'Enter') {
        const target = event.target;

        // Textareas report when 'enter' is pressed, but we want to ignore textareas since they don't submit forms.
        if (
          target.nodeName === 'BUTTON' ||
          (target.nodeName === 'TEXTAREA' && !target.hasAttribute('ignore-enter'))
        ) {
          return;
        }

        // Twitter emoji text area is a div, but has a class of twemoji-textarea
        // Using classList.contains or safe string check to prevent crashes
        if (target.classList && target.toString().indexOf('textarea') > -1) {
          return;
        }

        // Find visible/enabled default buttons
        const defaultButtons = document.querySelectorAll(
          "button[is-default='true']:not([disabled]):not([style*='display: none']):not([style*='visibility: hidden'])"
        );

        for (const button of defaultButtons) {
          button.click();
          event.preventDefault();
          return;
        }

        // No default button was found, but if ignore-enter is true we still ignore the enter
        if (target.nodeName === 'TEXTAREA' && target.hasAttribute('ignore-enter')) {
          event.preventDefault();
          return;
        }
      }
    };
  },
  unmounted(el) {
    // Clean up the event listener when the element is destroyed
    el.onkeydown = null;
  }
};